import { Button } from "@mui/material";
import { DialogModal } from "@zfp-akademie-a-s/zfp-design";
import type { SearchedClient } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { getSearchedClientName } from "Infrastructure/Utils/ClientUtils";

type Props = {
  readonly client: SearchedClient | null;
  readonly onContinue: (client: SearchedClient) => void;
  readonly onClearBirthNumber: () => void;
};

export const FoundClientDialog = ({ client, onContinue, onClearBirthNumber }: Props) => {
  const { t } = useResource();

  return (
    <DialogModal
      size="sm"
      open={client !== null}
      onClose={onClearBirthNumber}
      closeLabel={t(Resources.NewAnalysis.FoundClientDialog.ClearBirthNumber)}
      title={t(Resources.NewAnalysis.FoundClientDialog.Title)}
      subtitle={t(Resources.NewAnalysis.FoundClientDialog.Text, { client: client ? getSearchedClientName(client) : "" })}
      primaryAction={
        <Button variant="contained" onClick={() => client && onContinue(client)}>
          {t(Resources.NewAnalysis.FoundClientDialog.Continue)}
        </Button>
      }
    />
  );
};
